import React, { useEffect, useState } from 'react'
import { getActivityJsonConfig } from '@/api/marketing'
import qs from 'qs'
import classNames from 'classnames'
import { callNativeByParams, isApp, userBridge } from '@penguin/utils'
import { trackSendImmediate } from '@/utils'
import styles from './index.module.css'

const preUrl = 'https://static.qiekj.com/static/webConfig/marketing-h5/'

const pxKeys = [
  'width',
  'height',
  'padding',
  'margin',
  'border',
  'top',
  'right',
  'bottom',
  'left',
  'font-size',
  'line-height',
]

const handleStyle = (item: any) => {
  const obj: any = {}
  for (const key in item) {
    if (pxKeys.includes(key)) {
      if (typeof item[key] === 'string' && item[key]?.includes('%')) {
        obj[key] = item[key]
      } else {
        obj[key] = `${item[key] / 16}rem`
      }
    } else {
      obj[key] = item[key]
    }
  }
  return obj
}

const ActivityPage = () => {
  const [config, setConfig] = useState<any>({})
  const { jsonKey, preview, hiddenNav } = qs.parse(window.location.search.slice(1))
  const isHiddenNav = hiddenNav === '1'
  const navInfo = callNativeByParams('getAppStateBarAndNavBarHeight') as {
    stateBarHeight: string
    navBarHeight: string
    webViewHeight: string
  }
  const getConfig = async () => {
    if (!jsonKey) return
    const res = await getActivityJsonConfig(preUrl + jsonKey + `.json?t=${Date.now()}`)
    if (res.title) {
      document.title = res.title
      trackSendImmediate({
        pageTitle: res.title,
        pageUrl: window.location.href,
        eventType: '曝光',
      })
    }
    setConfig(res)
  }
  useEffect(() => {
    getConfig()
    isHiddenNav &&
      userBridge('showOrHiddenStateBar', {
        isHidden: 1,
      })
    return () => {
      isHiddenNav &&
        userBridge('showOrHiddenStateBar', {
          isHidden: 0,
        })
    }
  }, [])

  const isPreview = preview === 'true'
  return (
    <div>
      {isHiddenNav && isApp() && (
        <div className={styles.back} style={{ paddingTop: (+navInfo?.stateBarHeight || 0) + 'px' }}>
          <img
            className={styles['back-icon']}
            src={'//static.qiekj.com/static/web/image/back-new-icon_1736499359934.png'}
            alt=''
            onClick={() => {
              userBridge('popWindow')
            }}
          />
        </div>
      )}
      <div className='w-full' style={{ fontSize: 0 }}>
        {config?.bgImgs?.map((item: string, index: number) => {
          return <img key={index} src={item} alt='' />
        })}
      </div>
      <div className='flex absolute top-0 flex-col items-center w-full'>
        {config?.divs?.map((item: any, index: number) => {
          return (
            <div
              style={handleStyle(item)}
              className={classNames(
                'absolute',
                isPreview && 'bg-black/50  break-words  break-all text-lg text-white',
              )}
              key={index}
              onClick={() => {
                trackSendImmediate({
                  pageTitle: config.title,
                  pageUrl: window.location.href,
                  clickType: item.clickType || `点击按钮${index + 1}`,
                  clickUrl: item.link,
                  eventType: '点击',
                })
                if (isApp()) {
                  callNativeByParams('jumpNativePage', {
                    url: item.link,
                  })
                } else {
                  window.location.href = item.link
                }
              }}
            >
              {isPreview ? (
                <a href={item.link} target='_blank' rel='noreferrer'>
                  {item.link}
                </a>
              ) : (
                ''
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ActivityPage
